import { render } from "./Tags.vue?vue&type=template&id=9362922e"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"

import "./Tags.vue?vue&type=style&index=0&id=9362922e&lang=css"
script.render = render

export default script